<script setup lang="ts">
import { ConfidentialPage } from '@features/legal'
</script>

<template>
  <confidential-page />
</template>
